import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginStateService } from '../../login/services/login-state.service';
import { User } from '../../login/models/user';
import { MailService } from './mail.service';

@Injectable()
export class MailStateService {
  _condition: string;
  _user: User;

  constructor(
    private router: Router,
    private loginStateService: LoginStateService,
    private mailService: MailService,
  ) { }

  get condition() {
    return this._condition;
  }

  set condition(condition: string) {
    this._condition = condition;
  }

  get user() {
    return this._user;
  }

  set user(user: User) {
    this._user = user;
  }

  reset() {
    this._condition = '';
    this._user = null;
  }

  setUserCondition() {
    if (this.user && this.condition) {
      if (this.condition === 'subscribe') {
        this.mailService.userMailSubscribe().subscribe(
          result => {
            if (result) {
              console.log(this.condition);
              this.router.navigate(['mail/subscribe-result']);
            }
          }
        );
      }
      if (this.condition === 'unsubscribe') {
        this.mailService.userMailUnsubscribe().subscribe(
          result => {
            if (result) {
              console.log(this.condition);
              this.router.navigate(['mail/unsubscribe-result']);
            }
          }
        );
      }
      this.reset();
    }
  }

}
